import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/views/login'
import Layout from '@/views/layout/Layout'

import chart from '@/views/index/chart'
import feedback from '@/views/index/feedback'

import UserList from '@/views/user/list'
import UserGroup from '@/views/user/group'

import VipList from '@/views/vip/list'
import VipOrder from '@/views/vip/order'
import VipSetting from '@/views/vip/setting'
import VipPageSetting from '@/views/vip/pageSetting'

// 预约
import booking from '@/views/booking/index'
import bookingList from '@/views/booking/list'


// 机构会员
import PartnerVipList from '@/views/partnerVip/list'
import PartnerVipSetting from '@/views/partnerVip/setting'
import PartnerVipOrder from '@/views/partnerVip/order'

import visitors from '@/views/visitor/list'

import movieOrder from '@/views/order/movieOrder'
import movieComment from '@/views/comment/movie'
import movieDanmu from '@/views/comment/danmu'

import historyPageComment from '@/views/comment/historyPage'

import PlatformAdmin from '@/views/admin/PlatformAdmin'
import TenantAdmin from '@/views/admin/TenantAdmin'
import ApplyAdmin from '@/views/admin/ApplyAdmin'
import RoleManage from '@/views/admin/RoleManage'

import topic from '@/views/topic/index2'

import partner from '@/views/partner/index'

import information from '@/views/movie/information'
import moviePanorama from '@/views/movie/moviePanorama'
import movieTrack from '@/views/movie/movieTrack'
import discussion from '@/views/movie/discussion'
import infoPageSetting from '@/views/movie/infoPageSetting'
import partnerMessage from '@/views/movie/partnerMessage'
import people from '@/views/movie/people'
import actors from '@/views/movie/actors'
import movie from '@/views/movie/movie'
import screening from '@/views/movie/screening'
import talk from '@/views/movie/talk'
import filmfest from '@/views/movie/filmfest'
import category from '@/views/movie/category'

import setting from '@/views/setting/index'
import movieSearch from '@/views/setting/searchSetting'
import timeLine from '@/views/setting/timeLine'
import timeLine2 from '@/views/setting/timeline2'
import about from '@/views/setting/about'
import support from '@/views/setting/support'
import sponsor from '@/views/setting/sponsor'
import supportEn from '@/views/setting/supportEn'
import sponsorEn from '@/views/setting/sponsorEn'

import tool from '@/views/tool/index'

Vue.use(Router)

export const constantRouterMap = [{
    path: '/login',
    name: 'Login',
    component: Login,
    hidden: true
  },
  { // 路由重定向
    path: '*',
    redirect: '/index',
    hidden: true
  }
]

export const asyncRouterMap = [{
    title: '主页',
    path: '/index',
    component: Layout,
    icon: '&#xe71c;',
    name: 'home',
    children: [{
        title: '报表',
        path: '/index/chart',
        component: chart
      },
      {
        title: '反馈列表',
        path: '/index/feedback',
        component: feedback
      }
    ],
    hidden: false,
    meta: {}
  },
  {
    title: '用户',
    path: '/user',
    component: Layout,
    icon: '&#xe719;',
    name: 'user',
    children: [{
        title: '用户列表',
        path: '/user/list',
        component: UserList
      },
      {
        title: '用户集合',
        path: '/user/group',
        component: UserGroup
      },
      {
        title: '历史访客',
        path: '/visitors',
        component: visitors
      }
    ],
    hidden: false,
    meta: {}
  },
  {
    title: 'VIP会员',
    path: '/vip',
    component: Layout,
    icon: '&#xe719;',
    name: 'vip',
    children: [{
        title: '平台VIP会员',
        path: '/vip/list',
        component: VipList
      },
      {
        title: '付费设置',
        path: '/vip/setting',
        component: VipSetting
      },
      {
        title: '页面设置',
        path: '/vip/page-setting',
        component: VipPageSetting
      },
      {
        title: '付费记录',
        path: '/vip/order',
        component: VipOrder
      }
    ],
    hidden: false,
    meta: {}
  },
  {
    title: '机构会员',
    path: '/partner-vip',
    component: Layout,
    icon: '&#xe719;',
    name: 'vip',
    children: [{
        title: '机构VIP会员',
        path: '/partner-vip/list',
        component: PartnerVipList
      },
      {
        title: '付费设置',
        path: '/partner-vip/setting',
        component: PartnerVipSetting
      },
      // { title: '页面设置', path: '/partner-vip/page-setting', component: VipPageSetting },
      {
        title: '付费记录',
        path: '/partner-vip/order',
        component: PartnerVipOrder
      }
    ],
    hidden: false,
    meta: {}
  },
  {
    title: '订单',
    name: 'order',
    path: '/order',
    component: Layout,
    icon: '&#xe703;',
    children: [{
      title: '电影订单',
      name: 'movieOrder',
      path: '/order/movie-order',
      component: movieOrder,
      meta: {
        badge: 0
      }
    }],
    hidden: false,
    meta: {
      badge: 0
    }
  },
  {
    title: '管理',
    path: '/admin',
    name: 'admin',
    component: Layout,
    icon: '&#xe6f6;',
    children: [{
        title: '角色管理',
        path: '/admin/role',
        component: RoleManage
      },
      {
        title: '平台管理员',
        path: '/admin/platform-admin',
        component: PlatformAdmin
      },
      {
        title: '机构管理员',
        path: '/admin/tenant',
        component: TenantAdmin
      },
      {
        title: '添加管理员',
        path: '/admin/apply-admin',
        component: ApplyAdmin
      }
    ],
    hidden: false,
    meta: {}
  },
  {
    title: '评论',
    name: 'comment',
    path: '/comment',
    component: Layout,
    icon: '&#xe720;',
    children: [{
        title: '电影评论',
        name: 'movieComment',
        path: '/comment/movie',
        component: movieComment,
        meta: {
          badge: 0
        }
      },
      {
        title: '电影弹幕',
        name: 'movieDanmu',
        path: '/comment/danmu',
        component: movieDanmu,
        meta: {
          badge: 0
        }
      },
      {
        title: '历史切片评论',
        name: 'historyPageComment',
        path: '/comment/history-page',
        component: historyPageComment,
        meta: {
          badge: 0
        }
      }
    ],
    hidden: false,
    meta: {
      badge: 0
    }
  },
  {
    title: '预约',
    name: 'Booking',
    path: '/booking',
    component: Layout,
    icon: '&#xe70d;',
    children: [{
        title: '预约列表',
        path: '/booking/list',
        component: bookingList
      },
      {
        title: '创建预约',
        path: '/booking/index',
        component: booking
      }
    ],
    hidden: false,
    meta: {}
  },
  {
    title: '档案馆',
    name: 'archives',
    path: '/archives',
    component: Layout,
    icon: '&#xe71a;',
    children: [{
        title: '人物',
        path: '/archives/people',
        component: people
      },
      {
        title: '演员',
        path: '/archives/actors',
        component: actors
      },
      {
        title: '历史切片',
        path: '/archives/history',
        component: timeLine
      },
      {
        title: '时间线',
        path: '/archives/time-line',
        component: timeLine2
      },
      {
        title: '专题',
        path: '/archives/topic',
        component: topic
      }
    ],
    hidden: false,
    meta: {}
  },
  {
    title: '电影院',
    name: 'movie',
    path: '/movie',
    component: Layout,
    icon: '&#xe727;',
    children: [{
        title: '电影分类',
        path: '/movie/category',
        component: category
      },
      {
        title: '电影',
        path: '/movie/index',
        component: movie
      },
      {
        title: '放映项目',
        path: '/movie/screening',
        component: screening
      },
      // { title: '采访对谈', path: '/movie/talk', component: talk },
      {
        title: '合作方',
        path: '/movie/partner',
        component: partner
      },
      {
        title: '合作方电影',
        path: '/partner-movie/index',
        props: {
          type: 'partner'
        },
        component: movie
      }
    ],
    hidden: false,
    meta: {}
  },
  {
    title: '资讯台',
    name: 'news',
    path: '/news',
    component: Layout,
    icon: '&#xe74d;',
    children: [{
        title: '公告',
        path: '/news/information',
        component: information
      },
      {
        title: '电影节',
        path: '/news/filmfest',
        component: filmfest
      },
      {
        title: '展映',
        path: '/news/track',
        component: moviePanorama
      },
      {
        title: '动态',
        path: '/news/panorama',
        component: movieTrack
      },
      {
        title: '专访',
        path: '/news/discussion',
        component: discussion
      },
      {
        title: '合作方资讯',
        path: '/news/partner-message',
        component: partnerMessage
      },
      {
        title: '资讯排序',
        path: '/news/info-page-setting',
        component: infoPageSetting
      }
    ],
    hidden: false,
    meta: {}
  },
  {
    title: '中心',
    name: 'center',
    path: '/center',
    component: Layout,
    icon: '&#xe73c;',
    children: [{
        title: '关于',
        path: '/center/about',
        component: about
      },
      {
        title: '联络',
        path: '/center/support',
        component: support
      },
      {
        title: '联络(英文)',
        path: '/center/support_en',
        component: supportEn
      },
      {
        title: '赞助',
        path: '/center/sponsor',
        component: sponsor
      },
      {
        title: '赞助(英文)',
        path: '/center/sponsor_en',
        component: sponsorEn
      }
    ],
    hidden: false,
    meta: {}
  },
  {
    title: '设置',
    path: '/settings',
    component: Layout,
    icon: '&#xe757;',
    name: 'settings',
    children: [{
        title: '基本设置',
        path: '/settings',
        component: setting
      },
      {
        title: '搜索设置',
        path: '/settings/search-setting',
        component: movieSearch
      }
    ],
    hidden: false,
    meta: {}
  },
  {
    title: '工具',
    name: 'tool',
    path: '/tool',
    component: Layout,
    icon: '&#xe76a;',
    children: [{
      title: '工具',
      path: '/tool',
      component: tool
    }],
    hidden: false,
    meta: {}
  }
]

export default new Router({
  mode: 'history',
  routes: [...asyncRouterMap, ...constantRouterMap]
})



// WEBPACK FOOTER //
// ./src/router/index.js